import instance from '../utils/axios';

export interface Notification {
  id: number;
  user_id: number;
  company_id: number;
  type: string;
  title: string;
  message: string;
  reference_type: string;
  reference_id: number | null;
  design_no: string | null;
  is_read: boolean;
  created_at: string;
}

const notificationsApi = {
  getAll: async (params?: { limit?: number; offset?: number; unread_only?: boolean }) => {
    const response = await instance.get<{ notifications: Notification[]; total: number }>('/notifications', { params });
    return response.data;
  },

  getUnreadCount: async () => {
    const response = await instance.get<{ count: number }>('/notifications/unread-count');
    return response.data.count;
  },

  markAsRead: async (id: number) => {
    await instance.put(`/notifications/${id}/read`);
  },

  markAllAsRead: async () => {
    await instance.put('/notifications/read-all');
  }
};

export default notificationsApi;
